export default __webpack_public_path__ + "static/media/star-empty.cf42130c.svg";